import { AuthProvider } from "../context/AuthContext";
import { CartProvider } from "../context/CartContext";
import { GoogleMapsProvider } from "../context/GoogleMapsContext";
import { ModeProvider } from "../context/ModeContext";
import { ThemeContextProvider } from "../context/ThemeContext";
import { UserProvider } from "../context/UserContext";

export function AppProviders({ children }) {
  return (
    <ThemeContextProvider>
      <GoogleMapsProvider>
        <AuthProvider>
          <UserProvider>
            <ModeProvider>
              <CartProvider>{children}</CartProvider>
            </ModeProvider>
          </UserProvider>
        </AuthProvider>
      </GoogleMapsProvider>
    </ThemeContextProvider>
  );
}
